import React, {useCallback, useEffect, useState} from 'react';
import { connect } from 'react-redux';
import {Form, Input, Button, notification, Spin, message} from 'antd';
import  { bindActionCreators } from 'redux';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { hasErrors, isExplorerOrEdge } from '../../helpers';
import login from '../../Actions/login';
import { Link } from 'react-router-dom';
import auth from '../../auth';
import { persistor } from '../../Reducers/';
import { pageGA } from '../../Helpers/GoogleAnalytics';
import Footer from '../Footer';
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
const { authenticate } = login.actions;

function Login (props) {
	const { executeRecaptcha } = useGoogleReCaptcha();

	const handleReCaptchaVerify = useCallback(async (formValues) => {
		if (!executeRecaptcha) {
			message.warning('El captcha es incorrecto, refresque la página.');
			return;
		}
		formValues['token'] = await executeRecaptcha('EfiscoLogin');
		handleSubmit(formValues)
	}, [executeRecaptcha]);
	
	const { isLoadingAuthenticate } = props;
	const [form] = Form.useForm();
	 //this is the equivalent to didMount
	 useEffect(() => {		
		persistor.purge();
		auth.clearStorages();
		if(isExplorerOrEdge())
			notification.open({
				message: '',
				description:
				'Para mejorar tu experiencia en este sitio te recomendamos utilizar el navegador Google chrome',
				icon: <img src="./img/chrome-logo.svg" alt="Chrome" />,
				btn: <a href="https://www.google.com/chrome/"> Descargar</a>,
				duration: 5
			});
		pageGA(); 
  	}, []);
	 
	const handleSubmit = values => {
		const { history } = props;
		props.authenticate({values, history});
		form.resetFields(['password']);
	}

	const getTimeOfTheDay = () => {
		const today = new Date();
		const currentHours = today.getHours();		
		let banner = 'img/efisco-banner-morning.jpg';	
		if (currentHours < 18 && currentHours >= 12)
			banner = 'img/efisco-banner-afternoon.jpg';
		else if( currentHours > 18)
			banner = 'img/efisco-banner-night.jpg';
		return banner;
	}
	
		return (
			<div className="login-wrapper">				
				<Form form={form} onFinish={handleReCaptchaVerify} >
					<div className="header-form">
						<h1 className="regular-text">Herramienta efisco, gestión y conciliación de CFDI</h1>
						<img className="center-block logo" style={{ marginTop: '20px' }} src='./img/logo-efisco.png' alt="Efisco"/>
						<span className="blue-text regular-text">Iniciar Sesión</span>
						<p className="light-text text-justify" style={{ marginTop: '12px' }}>
							Te damos la bienvenida a tu herramienta SW smarter® | efisco, ingresa tu nombre de usuario y contraseña para acceder:
						</p>
					</div>
					<Form.Item
						style={{ marginBottom: '55px' }}
						name="username"
						rules={[
							{
								type: "email",
								message: "El correo electrónico no es válido"
							},
							{ required: true, message: "¡Favor de introducir su usuario!" }
						 ]}
						>	
						<Input
							prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)', width:'100%' }} />}
							placeholder="Correo electrónico"
						/>						
					</Form.Item>
					<Form.Item						
						name='password'
						rules={[
							{ required: true, message: "¡Favor de introducir su contraseña!" }
						 ]}
					>
						<Input.Password
							prefix={<LockOutlined type="lock" style={{ color: 'rgba(0,0,0,.25)',width:'100%' }} />}
							type="password"
							placeholder="Contraseña"
							visibilityToggle={true}
						/>
					</Form.Item>
					<div className="center-button-login" style={{marginTop: '40px'}}>
						<Button type="primary" key="back" htmlType="submit" disabled={
					
						form.getFieldsError().filter(({ errors }) => errors.length)
						.length > 0
						}>
							Iniciar sesión
						</Button>
					</div>			
					<div className="text-center" style={{marginTop:'20px'}}>
						<div className="regular-text" style={{fontSize:'16px'}} >¿Olvidaste tu contraseña?</div>
						<Link to="/recover-password" className="em">Recuperar contraseña</Link>
					</div>
					<Footer column={true}/>
					{
						isLoadingAuthenticate &&
						<div className="loading-container loading-absolute">
							<Spin size="large" tip="Cargando" />
						</div>
					}
				</Form>
				<div className="banner-area" style={{ backgroundImage: `url(${getTimeOfTheDay()})` }}>
				</div>
			</div>
		)
}

const mapStateToProps = state => {	
	return {
		isLoadingAuthenticate: state._genericComponents.loading.find('authenticateLoading'),
	};
};

const mapDispatchToProps = dispatch => {
	return {
		dispatch,
        ...bindActionCreators({authenticate},dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
